import Vue from 'vue';
import { BootstrapVue, IconsPlugin, VBScrollspyPlugin } from 'bootstrap-vue';

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VBScrollspyPlugin);
